import { Line, mixins } from "vue-chartjs";
const {getImageURL} = require("@/components/General/utils")
export default {
  name: "line-chart",
  extends: Line,
  props: {
    chartData: {
      type: Object,
    },
    extraOptions: {
      type: Object,
    },
    extraData : {
      type : Object,
      default : function(){
        return {}
      }
    }
  },
  data() {
    return {};
  },
  mixins: [mixins.reactiveProp],
  mounted() {
    this.$watch(
      "chartData",
      (newVal) => {
        if (newVal && newVal.length) {
          this.renderChart(newVal, this.extraOptions);
        }
      },
      { immediate: true }
    );
    this.$watch(
      "extraOptions",
      (newVal) => {
        if (newVal && newVal.length) {
           this._chart.destroy();
           this.renderChart(this.chartData, newVal);
        }
      },
      { immediate: true }
    );

    // Draw Image 
    this.addPlugin({
      id: "image-label",
      afterDraw: (chart) => {
        var ctx = chart.chart.ctx;
        var xAxis = chart.scales["x-axis-0"];
        var yAxis = chart.scales["y-axis-0"];
        var yAxisData = this.chartData.datasets[0].data;

        yAxisData.forEach((value, index) => {
          var x = xAxis.getPixelForValue(value.x);
          var y = yAxis.getPixelForValue(value.y);
          let images = this.chartData.images;

          if (images[index]) {
            var image = new Image();
            image.src = getImageURL(images[index].file)
            image.onload = function(){
              ctx.drawImage(
                image,
                x - images[index].width / 2,
                y - images[index].height / 2,
                images[index].width,
                images[index].height
              );
            } 
          }
        });
      },
    });

    if (this.chartData.is_user_select_points) {
      // Get and Draw clicked point
      this.addPlugin({
        id: "click-event",
        afterEvent: (chart, args) => {
          if (args.type == "click") {
            var yTop = chart.chartArea.top;
            var yBottom = chart.chartArea.bottom;

            var yMin = chart.scales["y-axis-0"].min;
            var yMax = chart.scales["y-axis-0"].max;

            var newY = 0;
            if (args.native.offsetY <= yBottom && args.native.offsetY >= yTop) {
              newY = Math.abs((args.native.offsetY - yTop) / (yBottom - yTop));
              newY = (newY - 1) * -1;
              newY = newY * Math.abs(yMax - yMin) + yMin;
            }

            const xTop = chart.chartArea.left;
            const xBottom = chart.chartArea.right;
            let xMin = chart.scales["x-axis-0"].min;
            let xMax = chart.scales["x-axis-0"].max;
            
            // If custom labels, then use the indexes of array
            if(this.extraData.is_custom_x_labels){
              xMin = this.chartData.labels.findIndex(r => r === xMin)
              xMax = this.chartData.labels.findIndex(r => r === xMax)
            }

            var newX = 0;

            if (args.native.offsetX <= xBottom && args.native.offsetX >= xTop) {
              newX = Math.abs((args.native.offsetX - xTop) / (xBottom - xTop));
              newX = newX * Math.abs(xMax - xMin) + xMin;
            }

            let stepX = (this.extraData.is_custom_x_labels) ? 1 : this.extraOptions.scales.xAxes[0].ticks.stepSize;
            let stepY = this.extraOptions.scales.yAxes[0].ticks.stepSize;

            const user_coord = {
              x: Math.round(newX/stepX) * stepX,
              y: Math.round(newY/stepY) * stepY,
            };

            if(this.extraData.is_custom_x_labels){
              user_coord['x'] = this.chartData.labels[user_coord['x']]
            }
            
            this.$emit("userCoordinate", user_coord)

            if(this.extraData.is_allow_single_selection){
              // Remove the last lata if present
              if(this.chartData.datasets[0].data.length){
                this.chartData.datasets[0].data.splice(0, 1)
              }
            }
            this.chartData.datasets[0].data.push(user_coord);
            this.renderChart(this.chartData, this.extraOptions);
          }
        },
      });
    }

    this.renderChart(this.chartData, this.extraOptions);
  },
};
